export default __webpack_public_path__ + "static/media/logo.d0d0e310.svg";